import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-th-cubetransparent",
  "use": "icon-th-cubetransparent-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"icon-th-cubetransparent\">\n<path d=\"M27.7075 11.2925L20.7075 4.2925C20.6146 4.19967 20.5042 4.12605 20.3829 4.07586C20.2615 4.02568 20.1314 3.9999 20 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V20C4.00011 20.2624 4.10337 20.5143 4.2875 20.7013L11.2875 27.7013C11.3805 27.7958 11.4914 27.8709 11.6137 27.9222C11.7361 27.9735 11.8674 27.9999 12 28H27C27.2652 28 27.5196 27.8946 27.7071 27.7071C27.8946 27.5196 28 27.2652 28 27V12C28.0001 11.8686 27.9743 11.7385 27.9241 11.6172C27.8739 11.4958 27.8003 11.3854 27.7075 11.2925ZM21 7.41375L24.5863 11H21V7.41375ZM11 24.5863L7.41375 21H11V24.5863ZM11 19H6V7.41375L11 12.4137V19ZM7.41375 6H19V11H12.4137L7.41375 6ZM19 13V19H13V13H19ZM13 26V21H19.5863L24.5863 26H13ZM26 24.5863L21 19.5863V13H26V24.5863Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/th-cubetransparent.svg
// module id = IMpV
// module chunks = 84